import { BaseDto } from "../common/baseDto";
import { formatDate, toLocalDateTime } from "src/utils/string/stringUtil";

export interface ProductDowntimeDto extends BaseDto {

	productResultNo:	string;				// 생산실적번호(기본키)
	downtimeNo:			string;				// 비가동번호(기본키)
	compCd:				string;				// 사업장코드
	compNm:				string;				// 사업장명
	productDt:			string | undefined;	// 일자
	orderType:			string;				// 지시구분/ORDTYPE.
	workplaceCd:		string;				// 공정코드/mst_workplace.
	workplaceNm:		string;				// 공정명
	jobTeam:			string;				// 작업조/JOBTEAM.
	itemCd:				string;				// 품목코드/ITEMCD.MSTITEM
	itemNm:				string;				// 품목명
	itemSpec:			string;				// 품목규격
	itemUnit:			string;				// 품목단위
	productEmp:			string;				// 작업사원코드/EMPNO.MSTEMP
	productEmpNm:		string;				// 작업사원명
	fromTime:			string | undefined;	// 비가동시작시간
	toTime:				string | undefined;	// 비가동종료시간
	downtimeCase:		string;				// 비가동사유
	remark:				string;				// 비고

	inserted: boolean;
	isModified: boolean;
}


export const defaultProductDowntimeDto: ProductDowntimeDto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,
	
	productResultNo: '',
	downtimeNo: '',
	compCd: '',
	compNm: '',
	productDt: formatDate(new Date()),
	orderType: '',
	workplaceCd: '',
	workplaceNm: '',
	jobTeam: '',
	itemCd: '',
	itemNm: '',
	itemSpec: '',
	itemUnit: '',
	productEmp: '',
	productEmpNm: '',
	fromTime: toLocalDateTime(new Date()),
	toTime: toLocalDateTime(new Date()),
	downtimeCase: '',
	remark: '',

	inserted: false,
	isModified: false

};
